export default __webpack_public_path__ + "static/media/NotAvailable.669d002e.svg";